import { type FormatConverterConfig } from '../../types';

export const formatConverterConfig: FormatConverterConfig = {
	title: 'formatData_mainTitle',
	lists: [
		{
			id: 'webp',
			title: 'WEBP',
			color: '#C6FFDD',
			items: [
				{
					id: 'image-to-webp',
					title: 'Image to WEBP',
					href: '/webp-converter',
				},
				{
					id: 'webp-to-jpeg',
					title: 'WEBP to JPEG',
					href: '/webp-to-jpeg-converter',
				},
				{
					id: 'webp-to-jpg',
					title: 'WEBP to JPG',
					href: '/webp-to-jpg-converter',
				},
				{
					id: 'webp-to-png',
					title: 'WEBP to PNG',
					href: '/webp-to-png-converter',
				},
			],
		},
		{
			id: 'heic',
			title: 'HEIC',
			color: '#FFF8C6',
			items: [
				{
					id: 'image-to-heic',
					title: 'Image to HEIC',
					href: '/image-to-heic-converter',
				},
				{
					id: 'heic-to-jpeg',
					title: 'HEIC to JPEG',
					href: '/heic-to-jpeg-converter',
				},
				{
					id: 'heic-to-jpg',
					title: 'HEIC to JPG',
					href: '/heic-to-jpg-converter',
				},
				{
					id: 'heic-to-png',
					title: 'HEIC to PNG',
					href: '/heic-to-png-converter',
				},
			],
		},
		{
			id: 'png',
			title: 'PNG',
			color: '#C6CAFF',
			items: [
				{ id: 'image-to-png', title: 'Image to PNG', href: '/png-converter' },
				{
					id: 'png-to-bmp',
					title: 'PNG to BMP',
					href: '/png-to-bmp-converter',
				},
				{
					id: 'png-to-jpeg',
					title: 'PNG to JPEG',
					href: '/png-to-jpeg-converter',
				},
				{
					id: 'png-to-jpg',
					title: 'PNG to JPG',
					href: '/png-to-jpg-converter',
				},
				{
					id: 'png-to-webp',
					title: 'PNG to WEBP',
					href: '/png-to-webp-converter',
				},
			],
		},
		{
			id: 'jpeg',
			title: 'JPEG',
			color: '#F9C6FF',
			items: [
				{
					id: 'image-to-jpeg',
					title: 'Image to JPEG',
					href: '/image-to-jpeg-converter',
				},
				{
					id: 'jpeg-to-bmp',
					title: 'JPEG to BMP',
					href: '/jpeg-to-bmp-converter',
				},
				{
					id: 'jpeg-to-jpg',
					title: 'JPEG to JPG',
					href: '/jpeg-to-jpg-converter',
				},
				{
					id: 'jpeg-to-png',
					title: 'JPEG to PNG',
					href: '/jpeg-to-png-converter',
				},
				{
					id: 'jpeg-to-tiff',
					title: 'JPEG to TIFF',
					href: '/jpeg-to-tiff-converter',
				},
				{
					id: 'jpeg-to-webp',
					title: 'JPEG to WEBP',
					href: '/jpeg-to-webp-converter',
				},
			],
		},
		{
			id: 'jpg',
			title: 'JPG',
			color: '#DDFFC6',
			items: [
				{
					id: 'image-to-jpg',
					title: 'Image to JPG',
					href: '/image-to-jpg-converter',
				},
				{
					id: 'jpg-to-bmp',
					title: 'JPG to BMP',
					href: '/jpg-to-bmp-converter',
				},
				{
					id: 'jpg-to-jpeg',
					title: 'JPG to JPEG',
					href: '/jpg-to-jpeg-converter',
				},
				{
					id: 'jpg-to-png',
					title: 'JPG to PNG',
					href: '/jpg-to-png-converter',
				},
				{
					id: 'jpg-to-tiff',
					title: 'JPG to TIFF',
					href: '/jpg-to-tiff-converter',
				},
				{
					id: 'jpg-to-webp',
					title: 'JPG to WEBP',
					href: '/jpg-to-webp-converter',
				},
			],
		},
		{
			id: 'tiff',
			title: 'TIFF',
			color: '#FFC6C6',
			items: [
				{
					id: 'image-to-tiff',
					title: 'Image to TIFF',
					href: '/image-to-tiff-converter',
				},
				{
					id: 'tiff-to-jpeg',
					title: 'TIFF to JPEG',
					href: '/tiff-to-jpeg-converter',
				},
				{
					id: 'tiff-to-jpg',
					title: 'TIFF to JPG',
					href: '/tiff-to-jpg-converter',
				},
				{
					id: 'tiff-to-png',
					title: 'TIFF to PNG',
					href: '/tiff-to-png-converter',
				},
			],
		},
		{
			id: 'bmp',
			title: 'BMP',
			color: '#C6F8FF',
			items: [
				{
					id: 'image-to-bmp',
					title: 'Image to BMP',
					href: '/image-to-bmp-converter',
				},
				{
					id: 'bmp-to-jpeg',
					title: 'BMP to JPEG',
					href: '/bmp-to-jpeg-converter',
				},
				{
					id: 'bmp-to-jpg',
					title: 'BMP to JPG',
					href: '/bmp-to-jpg-converter',
				},
				{
					id: 'bmp-to-png',
					title: 'BMP to PNG',
					href: '/bmp-to-png-converter',
				},
			],
		},
	],
};
